
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class IndexationProfileGrid extends SiteEntityGrid<IndexationProfileRow, any> {
        protected getColumnsKey() { return IndexationProfileColumns.columnsKey; }
        protected getDialogType() { return IndexationProfileDialog; }
        protected getIdProperty() { return IndexationProfileRow.idProperty; }
        protected getInsertPermission() { return IndexationProfileRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexationProfileRow.localTextPrefix; }
        protected getService() { return IndexationProfileService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}